import { render } from "./toaster.vue?vue&type=template&id=55449b12&scoped=true&lang=pug"
import script from "./toaster.vue?vue&type=script&lang=js"
export * from "./toaster.vue?vue&type=script&lang=js"

import "./toaster.vue?vue&type=style&index=0&id=55449b12&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55449b12"]])

export default __exports__